import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const handleClick = () => {
    if (href) {
      if (href.startsWith('http')) {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        const el = document.querySelector(href);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
    onClick?.();
  };
  return <motion.button onClick={handleClick} initial={{
    opacity: 0,
    scale: 0.5,
    y: 30
  }} animate={{
    opacity: 1,
    scale: 1,
    y: [0, -4, 0],
    boxShadow: ['0 0 20px rgba(200,162,60,0.2)', '0 0 40px rgba(200,162,60,0.5)', '0 0 20px rgba(200,162,60,0.2)']
  }} transition={{
    opacity: {
      type: 'spring',
      stiffness: 260,
      damping: 20,
      delay: 0.6
    },
    scale: {
      type: 'spring',
      stiffness: 260,
      damping: 20,
      delay: 0.6
    },
    y: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1.5
    },
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1.5
    }
  }} whileHover={{
    scale: 1.07,
    boxShadow: '0 0 50px rgba(200,162,60,0.6)'
  }} whileTap={{
    scale: 0.95
  }} className={`
        relative overflow-hidden group font-cinzel font-bold tracking-wider uppercase
        bg-gold-gradient text-dark-bg px-8 py-4 rounded-sm
        border border-gold-light/50
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-173">
      {/* Continuous shimmer sweep */}
      <motion.div animate={{
      x: ['-100%', '200%']
    }} transition={{
      duration: 2.5,
      repeat: Infinity,
      ease: 'easeInOut',
      repeatDelay: 1
    }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent skew-x-12 pointer-events-none" data-id="element-174" />
      {/* Pulse ring */}
      <motion.div animate={{
      scale: [1, 1.5],
      opacity: [0.3, 0]
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'easeOut'
    }} className="absolute inset-0 rounded-sm border-2 border-gold pointer-events-none" data-id="element-175" />
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-176">
        {children}
      </span>
    </motion.button>;
}